

import React from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getCourseByPk, getUserProgress, markVideoComplete, unmarkVideoComplete } from '../../redux/actions/actions';
import CoursePlayer from '../player/Player';
import VideoContent from '../player/VideoContent';
import VideoTree from '../player/VideoTree';

import './course.css'

export default function Course() {
    const { id } = useParams();
    const dispatch = useDispatch();
    const token = useSelector(state => state.credentials.token);
    const userId = useSelector(state => state.user.id);
    const activeCourse = useSelector(state => state.sessionCourse);
    const courseProgress = useSelector(state => state.sessionCourseProgress);
    const [selectedVideo, setSelectedVideo] = React.useState(null);

    React.useEffect(() => {
        if (id && token) {
            dispatch(getCourseByPk(id, token));
            dispatch(getUserProgress(id, token));
        }
    }, [id, token, dispatch]);

    React.useEffect(() => {
        if (activeCourse && activeCourse.videos && activeCourse.videos.length > 0) {
            // Initialize with the first video or based on user progress
            setSelectedVideo(activeCourse.videos[0]);
        }
    }, [activeCourse]);

    const handleVideoSelect = (video) => {
        setSelectedVideo(video);
    };

    const handleNextVideo = () => {
        const currentIndex = activeCourse.videos.findIndex(v => v.id === selectedVideo.id);
        if (currentIndex < activeCourse.videos.length - 1) {
            setSelectedVideo(activeCourse.videos[currentIndex + 1]);
        }
    };

    const handleMarkComplete = () => {
        if (!selectedVideo || !activeCourse) return;

        const isCompleted = courseProgress[selectedVideo.id]?.completed;

        if (isCompleted) {
            dispatch(unmarkVideoComplete(selectedVideo.id, activeCourse.id, token));
        } else {
            dispatch(markVideoComplete(selectedVideo.id, activeCourse.id, token));
            // Optimistically move to the next video only when completing
            handleNextVideo();
        }
    };

    if (!activeCourse || !selectedVideo) {
        return <div>Cargando curso...</div>;
    }

    return (
        <section className='parent-course'>
            <div className='child-course-video mt-2'>
                <CoursePlayer 
                    videoUrl={selectedVideo.url} 
                    onVideoEnded={handleNextVideo} 
                />
            </div>
            <div className='d-flex flex-column child-course-tree mt-2'>
                <VideoTree 
                    videos={activeCourse.videos} 
                    onVideoSelect={handleVideoSelect}
                    selectedVideo={selectedVideo}
                    onMarkComplete={handleMarkComplete}
                    progress={courseProgress}
                />
            </div>
            <div className='child-course-videoinfo'>
                <VideoContent 
                    video={selectedVideo}
                    course={activeCourse}
                />
            </div>
        </section>
    )
}
